"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "usePrismic", {
  enumerable: true,
  get: function get() {
    return _usePrismic["default"];
  }
});
Object.defineProperty(exports, "fetcher", {
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
});
var _usePrismic = _interopRequireDefault(require("./usePrismic"));
var _fetcher = _interopRequireDefault(require("./fetcher"));